import footer from './footer';
import header from './header';
import maternite from './maternite';
import santeenfant from './santeenfant';
import promoespacesante from './promoespacesante';

export default {
	footer,
	header,
	maternite,
	santeenfant,
	promoespacesante
};
